module.exports = __webpack_public_path__ + "static/media/scholarship-5.22640947.jpg";